export const frFR = {
  lang: 'fr-FR',
  country: 'FR',
  flag: '🇫🇷',
  currency: '€',

  app: {
    sidebar: {
      dashboard: 'Tableau de bord',
      transactions: 'Transactions',
      pots: 'Cagnottes',
      receipts: 'Reçus',
      reports: 'Rapports',
      categories: 'Catégories',
      tags: 'Tags',
      budgets: 'Budget',
      recurring: 'Récurrents',
      settings: 'Paramètres',
      darkMode: 'Mode Sombre',
      lightMode: 'Mode Clair',
      logout: 'Déconnexion',
    },
    common: {
      loading: 'Chargement...',
      save: 'Enregistrer',
      cancel: 'Annuler',
      confirmTitle: 'Confirmer',
      delete: 'Supprimer',
      edit: 'Modifier',
      create: 'Créer',
      search: 'Rechercher',
      filter: 'Filtres',
      export: 'Exporter',
      type: 'Type',
      category: 'Catégorie',
      date: 'Date',
      amount: 'Montant',
      description: 'Description',
      actions: 'Actions',
      income: 'Revenu',
      expense: 'Dépense',
      name: 'Nom',
      color: 'Couleur',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer ?',
      noResults: 'Aucun résultat trouvé',
      status: 'Statut',
      error: 'Erreur',
      success: 'Succès',
      page: 'Page',
      of: 'sur',
      showing: 'Affichage',
      viewDetails: 'Voir les détails',
      tags: 'Tags',
      receipt: 'Reçu',
      receiptAttached: 'Reçu joint',
    },
    categoryLabels: {
      food: 'Alimentation',
      transport: 'Transport',
      shopping: 'Shopping',
      entertainment: 'Divertissement',
      health: 'Santé',
      education: 'Éducation',
      utilities: 'Factures',
      housing: 'Logement',
      travel: 'Voyage',
      other: 'Autre',
      salary: 'Salaire',
      investment: 'Investissement',
      freelance: 'Freelance',
      gift: 'Cadeau',
    },
    tags: {
      loading: 'Chargement des tags...',
      error: 'Impossible de charger vos tags. Veuillez réessayer.',
      title: 'Tags',
      subtitle: 'Créez des tags pour organiser et filtrer vos transactions',
      newTag: 'Nouveau Tag',
      noTags: 'Aucun tag créé',
      noTagsDescription: 'Les tags sont créés automatiquement lorsque vous utilisez #tag dans vos messages, ou vous pouvez les créer manuellement ici.',
      createFirst: 'Créer le premier tag',
      howToUse: 'Comment utiliser les tags',
      howToUseDescription: 'Ajoutez des tags à vos transactions via WhatsApp en utilisant #tag. Par exemple : "Déjeuner 35 euros #travail #repas". Les tags vous aident à filtrer et analyser vos dépenses.',
      form: {
        name: 'Nom du tag',
        namePlaceholder: 'travail, voyage, déjeuner...',
        nameHint: 'Sera converti en minuscules sans espaces',
        color: 'Couleur',
      },
      stats: {
        title: 'Statistiques',
        created: 'Tags créés',
        totalUsage: 'Total des utilisations',
        mostUsed: 'Le plus utilisé',
        unused: 'Non utilisé',
      },
      confirmDelete: 'Supprimer le Tag',
      deleteWarning: 'Êtes-vous sûr de vouloir supprimer le tag',
      deleteUsageWarning: 'Ce tag est utilisé dans {count} transactions. Le tag sera supprimé de ces transactions.',
    },
    pots: {
      title: 'Cagnottes',
      subtitle: 'Organisez votre argent dans différentes cagnottes par devise',
      loading: 'Chargement des cagnottes...',
      error: 'Impossible de charger vos cagnottes. Veuillez réessayer.',
      errorTitle: 'Erreur lors du chargement des cagnottes',
      newPot: 'Nouvelle Cagnotte',
      editPot: 'Modifier la Cagnotte',
      noPots: 'Aucune cagnotte créée',
      noPotsDescription: 'Créez des cagnottes pour organiser votre argent par devise ou objectif.',
      createFirst: 'Créer la première cagnotte',
      setDefault: 'Définir par défaut',
      transactions: 'transactions',
      confirmDelete: 'Supprimer la Cagnotte',
      confirmDeleteMessage: 'Êtes-vous sûr de vouloir supprimer la cagnotte',
      deleteWarning: 'Cette cagnotte contient {count} transactions qui seront déplacées vers la cagnotte par défaut.',
      form: {
        name: 'Nom',
        namePlaceholder: 'Ex : Épargne de précaution',
        description: 'Description (optionnelle)',
        descriptionPlaceholder: 'À quoi sert cette cagnotte ?',
        currency: 'Devise',
        color: 'Couleur',
      },
    },
    transactions: {
      loading: 'Chargement des transactions...',
      title: 'Transactions',
      subtitle: 'Gérez vos revenus et dépenses',
      searchPlaceholder: 'Rechercher par description, commerçant...',
      showing: 'Affichage de {count} sur {total} transactions',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette transaction ?',
      filters: {
        filters: 'Filtres',
        dateStart: 'Date de début',
        dateEnd: 'Date de fin',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        minAmount: 'Montant minimum',
        maxAmount: 'Montant maximum',
      },
      table: {
        description: 'Description',
        category: 'Catégorie',
        date: 'Date',
        amount: 'Montant',
        receipt: 'Reçu',
        actions: 'Actions',
      },
      viewReceipt: 'Voir le reçu',
      modal: {
        editTitle: 'Modifier la Transaction',
        detailsTitle: 'Détails de la Transaction',
        merchant: 'Commerçant',
        description: 'Description',
        tags: 'Tags',
        receipt: 'Reçu',
        receiptAttached: 'Reçu joint',
        createCategory: 'Créer une nouvelle catégorie',
      },
    },
    dashboard: {
      title: 'Tableau de bord',
      subtitle: 'Vue d\'ensemble de vos finances',
      period: {
        week: 'Semaine',
        month: 'Mois',
        year: 'Année',
      },
      cards: {
        income: 'Revenus',
        expense: 'Dépenses',
        expenses: 'Dépenses',
        balance: 'Solde',
        transactions: 'Transactions',
      },
      charts: {
        spending: 'Dépenses par Catégorie',
        trend: 'Tendance',
        byCategory: 'Dépenses par Catégorie',
      },
      recent: 'Transactions Récentes',
      viewAll: 'Voir tout',
      topCategories: 'Top Catégories',
      items: 'éléments',
      loading: 'Chargement du tableau de bord...',
    },
    settings: {
      title: 'Paramètres',
      subtitle: 'Gérez votre profil et vos préférences',
      profile: {
        title: 'Profil',
        phone: 'Téléphone',
        phoneVerified: 'Vérifié',
        phoneHint: 'Le téléphone est utilisé pour l\'authentification et ne peut pas être modifié ici.',
        name: 'Nom',
        namePlaceholder: 'Votre nom',
        email: 'Email',
        emailPlaceholder: 'votre@email.com',
        emailHint: 'Utilisé pour recevoir des rapports et notifications.',
        verified: 'Vérifié',
      },
      preferences: {
        title: 'Préférences',
        language: 'Langue',
        languageHint: 'Langue utilisée dans les messages WhatsApp et les rapports.',
        timezone: 'Fuseau horaire',
      },
      subscription: {
        title: 'Abonnement',
        plan: 'Forfait',
        status: {
          active: 'Actif',
          trialing: 'Essai',
          pastDue: 'Paiement en attente',
          past_due: 'Paiement en attente',
          canceled: 'Annulé',
          expired: 'Expiré',
        },
        trialEnds: 'L\'essai se termine le',
        trialEndsAt: 'L\'essai se termine le',
        nextBilling: 'Prochaine facturation',
        upgrade: 'Mettre à niveau',
        support: 'Contacter le Support',
        contactSupport: 'Contacter le Support',
        cancel: 'Annuler l\'abonnement',
        noSubscription: 'Aucun abonnement actif',
        noSubscriptionDesc: 'Souscrivez à un forfait pour débloquer toutes les fonctionnalités.',
        viewPlans: 'Voir les Forfaits',
        plans: {
          free: 'Gratuit',
          basic: 'Basic',
          starter: 'Starter',
          pro: 'Pro',
          professional: 'Professionnel',
          enterprise: 'Enterprise',
          vip: 'VIP',
        },
      },
      account: {
        title: 'Informations du Compte',
        id: 'ID du compte',
        createdAt: 'Compte créé le',
      },
      saveChanges: 'Enregistrer les Modifications',
      loading: 'Chargement des paramètres...',
      error: 'Erreur lors du chargement des paramètres',
      errorDesc: 'Impossible de charger vos informations. Veuillez réessayer.',
    },
    budgets: {
      title: 'Budgets',
      subtitle: 'Définissez des limites de dépenses par catégorie',
      loading: 'Chargement des budgets...',
      error: 'Erreur lors du chargement des budgets',
      errorDesc: 'Impossible de charger vos budgets. Veuillez réessayer.',
      newBudget: 'Nouveau Budget',
      noBudgets: 'Aucun budget défini',
      noBudgetsDesc: 'Créez des budgets pour contrôler vos dépenses par catégorie et recevoir des alertes.',
      createFirst: 'Créer le premier budget',
      period: {
        monthly: 'Mensuel',
        yearly: 'Annuel',
      },
      status: {
        safe: 'Dans le budget',
        warning: 'Proche de la limite',
        danger: 'Limite dépassée !',
      },
      spent: 'dépensé',
      limit: 'Limite',
      remaining: 'Restant',
      exceeded: 'Dépassé',
      summary: {
        totalBudgeted: 'Total Budgété',
        totalSpent: 'Total Dépensé',
        overBudget: 'Dépassement',
        budget: 'budget',
        budgets: 'budgets',
      },
      tips: {
        title: 'Conseils pour un bon budget',
        tip1: 'Commencez par les catégories où vous dépensez le plus',
        tip2: 'Définissez des limites réalistes basées sur votre historique',
        tip3: 'Utilisez l\'alerte à 80% pour agir avant de dépasser',
        tip4: 'Révisez vos budgets mensuellement',
      },
      confirmDelete: 'Supprimer le Budget',
      confirmDeleteMsg: 'Êtes-vous sûr de vouloir supprimer le budget',
      form: {
        newBudget: 'Nouveau Budget',
        editBudget: 'Modifier le Budget',
        budgetName: 'Nom du budget',
        budgetNamePlaceholder: 'Ex: Alimentation mensuelle, Transport...',
        category: 'Catégorie (optionnel)',
        allExpenses: 'Toutes les dépenses',
        limit: 'Limite',
        period: 'Période',
        alertThreshold: 'Alerter à',
        alertDescription: 'Vous serez notifié lorsque vos dépenses atteindront ce pourcentage de la limite.',
        preview: 'Aperçu',
        save: 'Enregistrer',
        create: 'Créer',
      },
    },
    categories: {
      title: 'Catégories',
      subtitle: 'Gérez vos catégories de revenus et dépenses',
      loading: 'Chargement des catégories...',
      error: 'Erreur lors du chargement des catégories',
      errorDesc: 'Impossible de charger vos catégories. Veuillez réessayer.',
      newCategory: 'Nouvelle Catégorie',
      myCategories: 'Mes Catégories',
      systemCategories: 'Catégories Système',
      systemCategoriesDesc: 'Ces catégories sont par défaut et ne peuvent pas être modifiées.',
      noCustomCategories: 'Aucune catégorie personnalisée',
      noCustomCategoriesDesc: 'Créez des catégories personnalisées pour mieux organiser vos finances.',
      createFirst: 'Créer la première catégorie',
      type: {
        income: 'Revenu',
        expense: 'Dépense',
      },
      deductible: 'Déductible',
      confirmDelete: 'Supprimer la Catégorie',
      confirmDeleteMsg: 'Êtes-vous sûr de vouloir supprimer la catégorie',
      deleteWarning: 'Les transactions existantes seront déplacées vers "Autres".',
      form: {
        newCategory: 'Nouvelle Catégorie',
        editCategory: 'Modifier la Catégorie',
        categoryName: 'Nom de la catégorie',
        categoryNamePlaceholder: 'Ex: Alimentation, Transport...',
        type: 'Type',
        icon: 'Icône',
        colour: 'Couleur',
        preview: 'Aperçu',
        taxDeductible: 'Déductible des impôts',
        save: 'Enregistrer',
        create: 'Créer',
      },
    },
    receipts: {
      title: 'Reçus',
      subtitle: 'Visualisez et gérez vos justificatifs fiscaux',
      loading: 'Chargement des reçus...',
      error: 'Erreur lors du chargement des reçus',
      errorDesc: 'Impossible de charger vos reçus. Veuillez réessayer.',
      status: {
        all: 'Tous les Statuts',
        processing: 'En traitement',
        completed: 'Terminés',
        failed: 'Échoué',
        manual_review: 'Révision Manuelle',
      },
      year: {
        all: 'Toutes les Années',
      },
      stats: {
        total: 'Total',
        completed: 'Terminés',
        processing: 'En traitement',
        failed: 'Échoué',
      },
      noReceipts: 'Aucun reçu',
      noReceiptsFiltered: 'Aucun reçu trouvé',
      noReceiptsDesc: 'Envoyez une photo de reçu via WhatsApp pour commencer',
      noReceiptsFilteredDesc: 'Ajustez les filtres pour voir plus de reçus',
      showing: 'Affichage de {count} sur {total} reçus',
      page: 'Page {current} sur {total}',
    },
    recurring: {
      title: 'Transactions Récurrentes',
      subtitle: 'Automatisez vos dépenses et revenus fixes',
      loading: 'Chargement des transactions récurrentes...',
      error: 'Erreur lors du chargement des transactions récurrentes',
      errorDesc: 'Impossible de charger vos transactions récurrentes. Veuillez réessayer.',
      newRecurring: 'Nouvelle Récurrente',
      noRecurring: 'Aucune transaction récurrente',
      noRecurringDesc: 'Configurez des transactions qui se répètent automatiquement, comme le loyer, les abonnements ou le salaire.',
      createFirst: 'Créer la première récurrente',
      active: 'Active',
      paused: 'En pause',
      activeCount: 'Actives ({count})',
      pausedCount: 'En pause ({count})',
      next: 'Prochaine',
      summary: {
        monthlyExpenses: 'Dépenses Mensuelles',
        monthlyIncome: 'Revenus Mensuels',
        netMonthly: 'Solde Mensuel',
      },
      frequency: {
        daily: 'Quotidienne',
        weekly: 'Hebdomadaire',
        monthly: 'Mensuelle',
        yearly: 'Annuelle',
      },
      dayOf: {
        everyDay: 'Chaque jour',
        every: 'Chaque',
        dayOfMonth: 'Le {day} du mois',
        annually: 'Annuellement',
      },
      actions: {
        pause: 'Mettre en pause',
        activate: 'Activer',
        processNow: 'Traiter maintenant',
      },
      tips: {
        title: 'À propos des Transactions Récurrentes',
        tip1: 'Les transactions sont créées automatiquement à la date programmée',
        tip2: 'Vous pouvez mettre en pause temporairement sans supprimer',
        tip3: 'Utilisez pour les dépenses fixes comme le loyer, l\'électricité, internet',
        tip4: 'Fonctionne aussi pour les revenus comme le salaire',
      },
      confirmDelete: 'Supprimer la Transaction Récurrente',
      confirmDeleteMsg: 'Êtes-vous sûr de vouloir supprimer la transaction récurrente',
      deleteWarning: 'Les transactions déjà créées ne seront pas affectées.',
      form: {
        newRecurring: 'Nouvelle Transaction Récurrente',
        editRecurring: 'Modifier la Transaction Récurrente',
        description: 'Description',
        descriptionPlaceholder: 'Ex: Loyer, Netflix, Salaire...',
        amount: 'Montant',
        category: 'Catégorie',
        selectCategory: 'Sélectionnez une catégorie',
        selectPot: 'Sélectionnez une cagnotte (optionnel)',
        frequencyLabel: 'Fréquence',
        dayOfMonth: 'Jour du mois',
        dayOfWeek: 'Jour de la semaine',
        day: 'Jour',
        startDate: 'Date de début',
        endDate: 'Date de fin (optionnel)',
        preview: 'Aperçu',
        save: 'Enregistrer',
        create: 'Créer',
        daysOfWeek: {
          monday: 'Lundi',
          tuesday: 'Mardi',
          wednesday: 'Mercredi',
          thursday: 'Jeudi',
          friday: 'Vendredi',
          saturday: 'Samedi',
          sunday: 'Dimanche',
        },
      },
    },
    reports: {
      title: 'Rapports Fiscaux',
      subtitle: 'Résumés annuels pour la déclaration d\'impôts',
      loading: 'Chargement des rapports...',
      error: 'Erreur lors du chargement des rapports',
      errorDesc: 'Impossible de charger vos rapports. Veuillez réessayer.',
      year: {
        all: 'Toutes les années',
      },
      noReports: 'Aucun rapport',
      noReportsFiltered: 'Aucun rapport trouvé',
      noReportsDesc: 'Vos rapports fiscaux apparaîtront ici à la fin de chaque année.',
      noReportsFilteredDesc: 'Il n\'y a pas de rapports pour l\'année {year}.',
      generatedOn: 'Généré le',
      card: {
        income: 'Revenus',
        expenses: 'Dépenses',
        deductible: 'Déductibles',
        balance: 'Solde',
      },
      country: {
        BR: 'Brésil',
        GB: 'Royaume-Uni',
      },
      tips: {
        title: 'À propos des Rapports Fiscaux',
        desc: 'Les rapports sont générés automatiquement à la fin de chaque année fiscale.',
        tip1: 'Brésil : Année fiscale de janvier à décembre',
        tip2: 'Royaume-Uni : Année fiscale d\'avril à mars',
      },
    },
  },

  nav: {
    pricing: 'Tarifs',
    features: 'Fonctionnalités',
    howItWorks: 'Comment ça marche',
    login: 'Connexion',
  },

  hero: {
    badge: 'Gestion financière sans friction',
    title: 'Gérez vos finances via WhatsApp',
    subtitle: 'Envoyez un message, une photo ou un audio. L\'IA enregistre, catégorise et organise tout pour vous.',
    cta: 'Commencer Gratuitement',
    ctaSubtext: '14 jours gratuits, sans carte',
    ukOnly: 'Disponible uniquement pour les numeros britanniques pour le moment',
    trustedBy: 'Simple comme envoyer un message',
  },

  howItWorks: {
    title: 'Comment ça marche',
    subtitle: 'Trois façons d\'enregistrer. Zéro effort.',
    step1: {
      icon: '💬',
      title: 'Texte',
      description: 'Tapez naturellement : "50 déjeuner", "+500 salaire", "uber hier c\'était pour le travail"',
      example: '"85 courses"',
    },
    step2: {
      icon: '📸',
      title: 'Photo',
      description: 'Envoyez une photo du reçu. L\'OCR extrait automatiquement le montant, le magasin, le numéro SIRET et les articles.',
      example: 'Photo du ticket de caisse',
    },
    step3: {
      icon: '🎤',
      title: 'Audio',
      description: 'Enregistrez un audio décrivant la dépense. Nous le transcrivons et l\'enregistrons.',
      example: '"J\'ai dépensé 200 à la station-service"',
    },
  },

  features: {
    title: 'Bien plus qu\'un simple suivi des dépenses',
    subtitle: 'Des outils puissants, une interface simple',
    list: [
      {
        icon: 'wallet',
        title: 'Cagnottes (Portefeuilles)',
        description: 'Organisez par compte : Société Générale, BNP, Projet X. Chaque cagnotte avec sa devise.',
        command: '"créer cagnotte Épargne"',
      },
      {
        icon: 'target',
        title: 'Budgets',
        description: 'Définissez des limites par catégorie. Alerte quand vous atteignez 80%.',
        command: '"budget 500 alimentation"',
      },
      {
        icon: 'hash',
        title: 'Tags',
        description: 'Utilisez des #hashtags pour organiser : "50 uber #client #projet-x"',
        command: '"mes dépenses #travail"',
      },
      {
        icon: 'repeat',
        title: 'Récurrents',
        description: 'Configurez les dépenses fixes. Loyer, Netflix, salaire - enregistré automatiquement.',
        command: '"créer récurrent 1500 loyer"',
      },
      {
        icon: 'globe',
        title: 'Multi-devises',
        description: '€, £, $, CHF. Taux mis à jour de la BCE. Tableau de bord consolidé.',
        command: '"50 usd déjeuner cagnotte Voyage"',
      },
      {
        icon: 'layout',
        title: 'Tableau de bord Web',
        description: 'Graphiques, filtres, exportation. Tout ce que vous enregistrez, visible sur le portail.',
        command: 'keepnota.com',
      },
    ],
  },

  commands: {
    title: 'Commandes Rapides',
    subtitle: 'Conversation naturelle. Rien à mémoriser.',
    list: [
      { cmd: '50 café', desc: 'Enregistre une dépense de 50€' },
      { cmd: '+2000 freelance', desc: 'Enregistre un revenu' },
      { cmd: 'résumé', desc: 'Affiche le résumé du mois' },
      { cmd: 'mes cagnottes', desc: 'Liste vos portefeuilles' },
      { cmd: 'supprimer dernier', desc: 'Supprime la dernière transaction' },
      { cmd: 'aide', desc: 'Liste toutes les commandes' },
    ],
  },

  audience: {
    title: 'Conçu pour ceux qui veulent la simplicité',
    subtitle: 'Si vous utilisez WhatsApp, vous savez déjà utiliser KeepNota',
    personas: [
      {
        icon: 'briefcase',
        title: 'Indépendants et Auto-entrepreneurs',
        description: 'Séparez le personnel du professionnel. Sachez exactement ce qui entre et sort.',
      },
      {
        icon: 'user',
        title: 'Finances Personnelles',
        description: 'Fini les tableurs. Enregistrez les dépenses au moment où elles se produisent.',
      },
      {
        icon: 'users',
        title: 'Couples et Familles',
        description: 'Cagnottes partagées. Chacun enregistre, tous suivent.',
      },
      {
        icon: 'plane',
        title: 'Voyageurs',
        description: 'Multi-devises automatique. Dépenses partout, tout converti.',
      },
    ],
  },

  comparison: {
    title: 'Pourquoi KeepNota ?',
    subtitle: 'Comparé aux alternatives',
    vsSpreadsheet: {
      title: 'vs Tableur',
      points: [
        'Sans ouvrir l\'ordinateur',
        'Enregistrement instantané',
        'Catégorisation automatique',
        'Photo du reçu = tout rempli',
      ],
    },
    vsApps: {
      title: 'vs Applications de Finance',
      points: [
        'Fonctionne sur WhatsApp (déjà utilisé quotidiennement)',
        'Zéro friction - envoyez juste un message',
        'OCR des reçus inclus',
        'Pas de notifications agaçantes',
      ],
    },
    vsManual: {
      title: 'vs Notes Manuelles',
      points: [
        'N\'oublie jamais d\'enregistrer',
        'Audio quand vous ne pouvez pas taper',
        'Historique toujours accessible',
        'Rapports automatiques',
      ],
    },
  },

  taxBonus: {
    title: 'Bonus : Prêt pour les Impôts',
    subtitle: 'Quand la période fiscale arrive, vos données sont déjà organisées',
    points: [
      'Catégories mappées aux déductions fiscales',
      'Numéro SIRET capturé automatiquement des reçus',
      'Rapport annuel exportable',
      'Séparez les dépenses déductibles avec des tags',
    ],
  },

  pricing: {
    title: 'Forfaits',
    subtitle: 'Commencez gratuitement. Passez à la version supérieure quand nécessaire.',
    monthly: '/mois',
    yearly: '/an',
    savePercent: 'Économisez 20%',
    basic: {
      name: 'Basic',
      price: '9,90',
      features: [
        '30 photos de reçus/mois',
        '20 audios/mois',
        'Textes illimités',
        'Tableau de bord et graphiques basiques',
        'Rapport mensuel',
        'Export CSV',
        'Conservation des reçus : 1 an',
      ],
    },
    pro: {
      name: 'Pro',
      price: '19,90',
      popular: 'Le Plus Populaire',
      features: [
        'Photos et audios illimités',
        'Tout du Basic +',
        'Graphiques et filtres avancés',
        'Comparatif mois par mois',
        'Export PDF',
        'Rapport annuel (impôts)',
        'Support prioritaire',
        'Conservation des reçus : 2 ans',
      ],
    },
    cta: 'Commencer Gratuitement',
    trial: '14 jours gratuits, annulez quand vous voulez',
  },

  referral: {
    title: 'Parrainez et Gagnez',
    subtitle: 'Partagez avec vos amis et gagnez des jours gratuits',
    tiers: [
      { range: '1-5 parrainages', reward: '7 jours gratuits chacun' },
      { range: '6-15 parrainages', reward: '10 jours gratuits chacun' },
      { range: '16+ parrainages', reward: '14 jours + crédits' },
    ],
    cta: 'En savoir plus',
  },

  faq: {
    title: 'Questions Fréquentes',
    items: [
      {
        q: 'Dois-je télécharger une application ?',
        a: 'Non ! Ça fonctionne à 100% via WhatsApp. Enregistrez simplement notre numéro et commencez à envoyer vos dépenses. Nous avons aussi un portail web pour voir les graphiques et rapports.',
      },
      {
        q: 'Mes données sont-elles sécurisées ?',
        a: 'Oui ! Nous utilisons le chiffrement de bout en bout, des serveurs sécurisés et respectons le RGPD. Vous pouvez exporter ou supprimer vos données à tout moment.',
      },
      {
        q: 'Puis-je annuler quand je veux ?',
        a: 'Bien sûr ! Sans engagement. Annulez à tout moment via WhatsApp en tapant "annuler". Vos données restent disponibles pendant 30 jours après l\'annulation.',
      },
      {
        q: 'Est-ce adapté aux auto-entrepreneurs ?',
        a: 'Parfait pour ça ! Utilisez des cagnottes pour séparer le compte personnel du professionnel, des tags pour les clients, et gardez le contrôle total des revenus et dépenses.',
      },
      {
        q: 'Comment fonctionne l\'OCR des reçus ?',
        a: 'Envoyez la photo du ticket de caisse ou de la facture. Notre IA extrait automatiquement : le montant total, le nom du magasin, le numéro SIRET, la date et même les articles. Vérifiez et c\'est terminé.',
      },
      {
        q: 'Puis-je utiliser plusieurs devises ?',
        a: 'Oui ! Nous prenons en charge l\'Euro, le Dollar, la Livre et le Franc Suisse. Chaque cagnotte peut avoir sa devise, et le tableau de bord affiche tout converti dans votre devise principale.',
      },
    ],
  },

  cta: {
    title: 'Commencez à organiser vos finances aujourd\'hui',
    subtitle: '14 jours gratuits. Sans carte. Annulez quand vous voulez.',
    button: 'Parler sur WhatsApp',
    secondary: 'Voir la démonstration',
  },

  footer: {
    copyright: '© 2025 KeepNota by Fig and Rosa Ltd. Tous droits réservés.',
    terms: 'Conditions d\'Utilisation',
    privacy: 'Confidentialité',
    tagline: 'Gestion financière via WhatsApp',
  },

  privacy: {
    title: 'Politique de Confidentialité',
    lastUpdate: 'Dernière mise à jour : Décembre 2024',
    intro: 'KeepNota ("nous", "notre" ou "Service") valorise la confidentialité des utilisateurs. Cette Politique de Confidentialité explique comment nous collectons, utilisons et protégeons vos informations.',
    sections: [
      {
        title: '1. Données que Nous Collectons',
        content: `Nous collectons les données suivantes lorsque vous utilisez KeepNota :
• **Numéro de téléphone** : Pour l'identification et la communication via WhatsApp
• **Messages envoyés** : Textes, audios et images de reçus que vous envoyez
• **Données extraites** : Montants, catégories et informations des reçus traités
• **Données d'utilisation** : Heures d'accès et interactions avec le service`,
      },
      {
        title: '2. Comment Nous Utilisons vos Données',
        content: `Nous utilisons vos données pour :
• Traiter et organiser vos reçus
• Générer des rapports et graphiques de dépenses
• Identifier les dépenses déductibles des impôts
• Améliorer nos services et algorithmes d'IA
• Envoyer des communications concernant votre compte et le service`,
      },
      {
        title: '3. Stockage et Sécurité',
        content: `Vos données sont stockées en toute sécurité :
• Chiffrement en transit (HTTPS/TLS)
• Stockage sur des serveurs sécurisés
• Accès restreint aux systèmes automatisés uniquement
• Sauvegardes régulières et redondance des données`,
      },
      {
        title: '4. Partage des Données',
        content: `**Nous ne vendons pas vos données.** Nous partageons uniquement avec :
• **Fournisseurs de services** : Traitement des paiements (Stripe), stockage (AWS)
• **IA/ML** : Google (Gemini) pour le traitement d'images et de texte - données anonymisées
• **Obligation légale** : Lorsque requis par la loi ou une décision de justice`,
      },
      {
        title: '5. Vos Droits (RGPD)',
        content: `Vous avez le droit de :
• **Accès** : Demander une copie de vos données
• **Rectification** : Corriger les données incorrectes
• **Suppression** : Demander la suppression de vos données
• **Portabilité** : Recevoir vos données dans un format structuré
• **Révocation** : Retirer votre consentement à tout moment

Pour exercer vos droits, envoyez un message sur notre WhatsApp ou email : privacy@keepnota.com`,
      },
      {
        title: '6. Conservation des Données',
        content: `Nous conservons vos données tant que votre compte est actif. Après annulation :
• Données financières : Conservées pendant 5 ans (obligation fiscale)
• Images des reçus : Supprimées sous 30 jours
• Données du compte : Supprimées sous 30 jours`,
      },
      {
        title: '7. Contact',
        content: `Pour toute question sur la confidentialité :
• Email : privacy@keepnota.com
• WhatsApp : Envoyez "CONFIDENTIALITÉ" à notre numéro`,
      },
    ],
  },

  feedback: {
    title: 'Envoyez vos Commentaires',
    subtitle: 'Votre avis nous aide à améliorer KeepNota',
    typeLabel: 'Type de commentaire',
    types: {
      general: 'Général',
      feature_request: 'Suggestion',
      bug: 'Bug/Erreur',
      complaint: 'Réclamation',
      praise: 'Compliment',
      account_deletion: 'Supprimer le compte',
    },
    messageLabel: 'Votre message',
    messagePlaceholder: 'Dites-nous ce que vous pensez...',
    ratingLabel: 'Évaluation (optionnelle)',
    nameLabel: 'Votre nom (optionnel)',
    namePlaceholder: 'Comment pouvons-nous vous appeler ?',
    emailLabel: 'Email (optionnel)',
    emailPlaceholder: 'votre@email.com',
    emailHint: 'Pour répondre à vos commentaires',
    submit: 'Envoyer',
    errors: {
      messageRequired: 'Veuillez écrire un message',
      messageTooShort: 'Message trop court (minimum 10 caractères)',
      submitFailed: 'Erreur lors de l\'envoi. Veuillez réessayer.',
    },
    success: {
      title: 'Commentaires envoyés !',
      message: 'Merci de partager votre avis. Nous l\'examinerons avec attention.',
    },
    backToHome: 'Retour à la page d\'accueil',
  },

  terms: {
    title: 'Conditions d\'Utilisation',
    lastUpdate: 'Dernière mise à jour : Décembre 2024',
    intro: 'En utilisant KeepNota, vous acceptez ces Conditions d\'Utilisation. Veuillez les lire attentivement.',
    sections: [
      {
        title: '1. À Propos du Service',
        content: `KeepNota est un service d'organisation des reçus et des dépenses via WhatsApp. Nous offrons :
• Traitement automatique des reçus par photo, audio ou texte
• Catégorisation et organisation des dépenses
• Rapports et graphiques de dépenses
• Identification des dépenses déductibles des impôts

Le service est fourni "tel quel" et peut être modifié à tout moment.`,
      },
      {
        title: '2. Inscription et Compte',
        content: `Pour utiliser KeepNota :
• Vous devez avoir 18 ans ou plus
• Fournir des informations exactes
• Maintenir votre numéro de téléphone à jour
• Ne pas partager l'accès avec des tiers

Vous êtes responsable de toutes les activités sur votre compte.`,
      },
      {
        title: '3. Utilisation Acceptable',
        content: `Vous acceptez de NE PAS :
• Utiliser le service à des fins illégales
• Envoyer du contenu offensant, diffamatoire ou illégal
• Tenter d'accéder aux systèmes ou données d'autres utilisateurs
• Utiliser des bots ou de l'automatisation non autorisée
• Revendre ou redistribuer le service`,
      },
      {
        title: '4. Paiements et Abonnement',
        content: `• Nous offrons une période d'essai gratuite de 14 jours
• Après l'essai, l'abonnement est facturé mensuellement
• Paiements traités via Stripe (carte de crédit)
• L'annulation peut être effectuée à tout moment
• Pas de remboursement pour les périodes partielles`,
      },
      {
        title: '5. Propriété Intellectuelle',
        content: `• KeepNota et ses composants sont la propriété de Figrosa
• Vous conservez la propriété de vos données et reçus
• Nous vous accordons une licence limitée pour utiliser le service
• Vous nous accordez une licence pour traiter vos données selon les besoins`,
      },
      {
        title: '6. Limitation de Responsabilité',
        content: `• KeepNota ne remplace pas les conseils comptables ou fiscaux
• Nous ne garantissons pas une précision absolue dans le traitement des reçus
• Nous ne sommes pas responsables des décisions fiscales basées sur le service
• Notre responsabilité est limitée au montant payé pour le service`,
      },
      {
        title: '7. Annulation',
        content: `Vous pouvez annuler à tout moment :
• Envoyez "ANNULER" via WhatsApp
• Accédez à votre compte sur le portail
• L'accès continue jusqu'à la fin de la période payée
• Vos données seront supprimées conformément à notre Politique de Confidentialité`,
      },
      {
        title: '8. Modifications des Conditions',
        content: `Nous pouvons modifier ces conditions à tout moment. Nous vous informerons via :
• Message sur WhatsApp
• Email (si enregistré)
• Avis sur le portail

L'utilisation continue après les modifications constitue une acceptation.`,
      },
      {
        title: '9. Contact',
        content: `Pour toute question sur les Conditions :
• Email : support@keepnota.com
• WhatsApp : Envoyez "AIDE" à notre numéro`,
      },
    ],
  },
};
